import BetModel from "../model/BetModel";
import Layout from "../utils/Layout";
import BaseView from "./BaseView";
import { MoneyFieldConfig } from "./AbstractMoneyField";
import { IObjectConfig } from "../baseConfigs/layoutConfigShema";
import App from "../App";
import GameEvents from "../const/GameEvents";
import ConsoleUtil from "../utils/ConsoleUtil";

export abstract class AbstractBitmapMoneyField extends BaseView{

    protected _config: BitmapMoneyFieldConfig;


    constructor(config?: BitmapMoneyFieldConfig) {
        super();
        if (!config) {
            this._config = new BitmapMoneyFieldConfig();
        } else {
            this._config = config;
        }

        App.dispatcher.on(GameEvents.UI_UPDATE, () => { this.createBoundsRect(); }, this);
    }

    abstract set style(style:BitmapMoneyFieldConfig);
    abstract get bounds(): {width: number, height: number};
    abstract set bounds(bounds: {width: number, height: number});

    abstract get value(): number;
    abstract set value(value: number);
    abstract set align(value: string);

    public abstract rescale(bounds:IObjectConfig);
    public abstract createBoundsRect(): void;
    public centerVertical() {
        ConsoleUtil.warn("NO VERICAL CENTERING AVAILABLE");
    }
 
    
}

export class BitmapMoneyFieldConfig extends MoneyFieldConfig {
    tint: number = 0xFFFFFF
}
